const RTF = new Intl.RelativeTimeFormat("en", { numeric: "always" });

export const formatRelativeTime = (d: Date, now: Date = new Date()): string => {
	const diffMs = d.getTime() - now.getTime();
	const sec = Math.round(diffMs / 1000);
	const min = Math.round(sec / 60);
	const hr = Math.round(min / 60);
	const day = Math.round(hr / 24);
	if (Math.abs(sec) < 45) return "just now";
	if (Math.abs(min) < 60) return RTF.format(min, "minute");
	if (Math.abs(hr) < 24) return RTF.format(hr, "hour");
	if (Math.abs(day) < 60) return RTF.format(day, "day");
	if (Math.abs(day) < 365) return RTF.format(Math.round(day / 30), "month");
	return RTF.format(Math.round(day / 365), "year");
};
